"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageEditor = ImageEditor;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var themes_1 = require("../../../../themes");
var mixins_1 = require("../../../../themes/mixins");
var _EXPORTS_1 = require("../../../../utils/_EXPORTS");
var renderRTEPlaceholderForOolibPreview_1 = require("../../../../utilsOolib/renderRTEPlaceholderForOolibPreview");
var Divider_1 = require("../../../Divider");
var SkeletonLoader_1 = require("../../../LoadersAndProgress/SkeletonLoader");
var Modal_1 = require("../../../Modals/Modal");
var Paddings_1 = require("../../../Paddings");
var AspectRatioShell_1 = __importDefault(require("../AspectRatioShell"));
var ConfirmDeleteModal_1 = require("./comps/ConfirmDeleteModal");
var EditToolbar_1 = require("./comps/EditToolbar");
var ImageActionsMenu_1 = require("./comps/ImageActionsMenu");
var ImageReposManager_1 = require("./comps/ImageReposManager");
var styled_1 = require("./styled");
var smallImageInputUIConditionsMet_1 = require("./utils/smallImageInputUIConditionsMet");
var useReorientImage_1 = require("./utils/useReorientImage");
var TextInputs_1 = require("../../../../v2/components/TextInputs");
/**
 * fiddle for dealing with rotation: https://jsfiddle.net/wunderbart/w1hw5kv1/
 */
function ImageEditor(_a) {
    var id = _a.id, readOnly = _a.readOnly, imageData = _a.value, defaultImageSpread = _a.defaultImageSpread, handleSingleImageDataChange = _a.handleSingleImageDataChange, handleDeleteSingleImage = _a.handleDeleteSingleImage, handleReplaceSingleImage = _a.handleReplaceSingleImage, aspectRatio = _a.aspectRatio, invert = _a.invert, handleUpload = _a.handleUpload, setImageUnderEdit = _a.setImageUnderEdit, //comes from ImageInput context if used inside it
    disableImageBorder = _a.disableImageBorder, stretchToFullHeight = _a.stretchToFullHeight, containerShape = _a.containerShape, omitEditorTools = _a.omitEditorTools, enableCaptions = _a.enableCaptions, 
    //sent by parent ImageEditor to child (modal) ImageEditor
    _underEditImageData = _a.underEditImageData, //ImageEditor passes this to its recursive self when opening in popup
    _setUnderEditImageData = _a.setUnderEditImageData, isInPopUp = _a.isInPopUp, isInRTE = _a.isInRTE, handleDragStart = _a.handleDragStart;
    var theme = (0, styled_components_1.useTheme)();
    var _b = theme || {}, LexicalTextEditor = _b.LexicalTextEditor, _c = _b.lexicalTextEditorHasValue, lexicalTextEditorHasValue = _c === void 0 ? function () { return false; } : _c, //we are just defaulting to false for oolib preview. Meaning, when previewing in oolib, since this function doesnt exist (as it has to be provided by okf-fe), we will always return false from it.
    //backwards compat
    _d = _b.richTextHasValue, //we are just defaulting to false for oolib preview. Meaning, when previewing in oolib, since this function doesnt exist (as it has to be provided by okf-fe), we will always return false from it.
    //backwards compat
    richTextHasValue = _d === void 0 ? function () { return false; } : _d; //temporarily passed thru from okf
    var _e = (0, react_1.useState)(_underEditImageData || undefined), underEditImageData = _e[0], setUnderEditImageData = _e[1];
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    //set state in parent imageeditor
    (0, react_1.useEffect)(function () {
        _setUnderEditImageData && _setUnderEditImageData(underEditImageData);
    }, [underEditImageData]);
    var props = arguments[0];
    /** rotation */
    /**
     * if underEditImageData exists, render the temp 'formattings' as well,
     * which are stored in underEditImageData.
     *
     * underEditImageData is merged into imageData, only if the 'formattings'
     * are 'saved'
     */
    var _f = underEditImageData || imageData, publicUrl = _f.publicUrl, _g = _f.imageSpread, imageSpread = _g === void 0 ? defaultImageSpread : _g, _h = _f.imageRotate, imageRotate = _h === void 0 ? 0 : _h, _j = _f.cropX, cropX = _j === void 0 ? 0 : _j, _k = _f.cropY, cropY = _k === void 0 ? 0 : _k;
    /**
     * repos management
     */
    var wrapperRef = (0, react_1.useRef)(null);
    var renderedImageRef = (0, react_1.useRef)(null);
    var isFirstMount = (0, react_1.useRef)(true);
    var _l = (0, react_1.useState)(undefined), fullWidthOrFullHeightImg = _l[0], setFullWidthOrFullHeightImg = _l[1];
    var _m = (0, useReorientImage_1.useReorientImage)({
        imageRotate: imageRotate,
        setFullWidthOrFullHeightImg: setFullWidthOrFullHeightImg,
        setUnderEditImageData: setUnderEditImageData,
        publicUrl: publicUrl,
        aspectRatio: aspectRatio,
        underEditImageData: underEditImageData,
        isFirstMount: isFirstMount,
        handleDeleteSingleImage: handleDeleteSingleImage,
        readOnly: readOnly
    }), reorientedImageTempUrl = _m.reorientedImageTempUrl, imageLazyLoading = _m.imageLazyLoading;
    var _o = (0, react_1.useState)(undefined), showDeleteImageModal = _o[0], setShowDeleteImageModal = _o[1];
    var inputRef = (0, react_1.useRef)(null);
    var _p = (0, react_1.useState)(undefined), editorStyle = _p[0], setEditorStyle = _p[1]; //alt: modal
    (0, react_1.useEffect)(function () { isFirstMount.current = false; }, []);
    var decideEditorStyle = function () {
        var _a = wrapperRef.current.getBoundingClientRect(), width = _a.width, height = _a.height;
        if (isInPopUp) {
            setEditorStyle("toolbar");
        }
        else if ((0, smallImageInputUIConditionsMet_1.smallImageInputUIConditionsMet)({ width: width, height: height }) || containerShape === 'circle') {
            setEditorStyle("modal");
        }
        else {
            setEditorStyle("toolbar");
        }
    };
    var modalStyleEditorIsCurrentlyOpen = function () {
        return editorStyle === "modal" && !!underEditImageData;
    };
    var genModalStyleEditor = function () { return (react_1.default.createElement(Modal_1.Modal, { title: "Edit Image", fitToContentHeight: screenWidth >= (0, mixins_1.getBreakPoint)('sm') ? true : false, desktopWidth: "500px" },
        react_1.default.createElement(Paddings_1.PaddingTop40, null,
            react_1.default.createElement(ImageEditor, __assign({}, props, { id: 'insideModal', underEditImageData: underEditImageData, setUnderEditImageData: setUnderEditImageData, isInPopUp: true }))))); };
    var genToolbarStyledEditor = function () { return (react_1.default.createElement(EditToolbar_1.EditToolbar, { setUnderEditImageData: setUnderEditImageData, underEditImageData: underEditImageData, imageData: imageData, handleSingleImageDataChange: handleSingleImageDataChange, setImageUnderEdit: setImageUnderEdit, //comes from ImageInput context if used inside it
        imageSpread: imageSpread, publicUrl: publicUrl, defaultImageSpread: defaultImageSpread, omitEditorTools: omitEditorTools, isInPopUp: isInPopUp })); };
    return (react_1.default.createElement("div", { id: id && id + '_ImageEditor', style: {
            position: "relative",
            height: stretchToFullHeight ? "100%" : "auto",
        } }, imageLazyLoading && !modalStyleEditorIsCurrentlyOpen() ? (react_1.default.createElement(AspectRatioShell_1.default, { key: "loaderShell", aspectRatio: aspectRatio, stretchToFullHeight: stretchToFullHeight, containerShape: containerShape, disableImageBorder: disableImageBorder },
        react_1.default.createElement(SkeletonLoader_1.SkeletonLoader, { style: { height: "100%" } }))) : (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(AspectRatioShell_1.default, { id: id, invert: invert, key: "imageShell", //by adding key we are forcing this AspectRatioShell to rerender, so that decideEditorStyle() calculation happens
            aspectRatio: aspectRatio, stretchToFullHeight: stretchToFullHeight, containerShape: containerShape, disableImageBorder: disableImageBorder, onShellPrepared: decideEditorStyle },
            showDeleteImageModal && (react_1.default.createElement(ConfirmDeleteModal_1.ConfirmDeleteModal, { showDeleteImageModal: showDeleteImageModal, setShowDeleteImageModal: setShowDeleteImageModal, handleDeleteSingleImage: handleDeleteSingleImage })),
            react_1.default.createElement(styled_1.StyledFullWidthImgWrapper, { ref: wrapperRef, invert: invert, disableImageBorder: disableImageBorder },
                react_1.default.createElement(styled_1.StyledImg, { ref: renderedImageRef, fullWidthOrFullHeightImg: fullWidthOrFullHeightImg, src: reorientedImageTempUrl || publicUrl, imageSpread: imageSpread, cropX: cropX, cropY: cropY, onTouchStart: handleDragStart && handleDragStart, onMouseDown: handleDragStart && handleDragStart }),
                underEditImageData !== undefined &&
                    !omitEditorTools.includes("reposition") && (react_1.default.createElement(ImageReposManager_1.ImageReposManager, { fullWidthOrFullHeightImg: fullWidthOrFullHeightImg, wrapperRef: wrapperRef, renderedImageRef: renderedImageRef, setUnderEditImageData: setUnderEditImageData })))),
        !readOnly && (react_1.default.createElement(styled_1.StyledImageEditToolbar, { underEditImageData: underEditImageData, containerShape: containerShape, isInPopUp: isInPopUp }, underEditImageData === undefined ? (react_1.default.createElement(ImageActionsMenu_1.ImageActionsMenu, { id: id, invert: invert, setUnderEditImageData: setUnderEditImageData, setImageUnderEdit: setImageUnderEdit, inputRef: inputRef, setShowDeleteImageModal: setShowDeleteImageModal, publicUrl: publicUrl, imageData: imageData, handleReplaceSingleImage: handleReplaceSingleImage, handleUpload: handleUpload, isInRTE: isInRTE })) : editorStyle === "toolbar" ? (genToolbarStyledEditor()) : (editorStyle === "modal" && genModalStyleEditor()))),
        enableCaptions && (readOnly &&
            !lexicalTextEditorHasValue(imageData.caption) &&
            !richTextHasValue(imageData.caption) //backwards compat cuz its possible caption data might be in draftjs shape
            ? null
            : react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(Divider_1.Divider, { invert: invert }),
                react_1.default.createElement("div", { style: {
                        borderRadius: "0.2rem",
                        padding: readOnly ? "1rem" : "2rem",
                        backgroundColor: invert ? themes_1.colors.greyColor90 : themes_1.colors.greyColor5,
                    } }, !LexicalTextEditor
                    ? react_1.default.createElement(TextInputs_1.TextInput //basically on oolib it renders this for preview purposes.
                    , { value: imageData.caption, onChange: function (id, val) {
                            handleSingleImageDataChange({
                                publicUrl: publicUrl,
                                imageData: __assign(__assign({}, imageData), { caption: val }),
                            });
                        } })
                    : react_1.default.createElement(LexicalTextEditor, { variant: 'simple', disableNewline: true, invert: invert, placeholder: "type caption for image (optional)", readOnly: readOnly, charLimit: 100, typo: "SANS_3", placeholderColor: invert ? themes_1.colors.greyColor70 : themes_1.colors.greyColor40, value: imageData.caption, onChange: function (id, val) {
                            handleSingleImageDataChange({
                                publicUrl: publicUrl,
                                imageData: __assign(__assign({}, imageData), { caption: val }),
                            });
                        } })),
                readOnly && react_1.default.createElement(Divider_1.Divider, { invert: invert })))))));
}
